<template>
  <MglGeojsonLayer
    v-if="hasLocations && locationsInFrame.length < 100"
    :source="geoJsonSource"
    :layerId="geoJsonlayer.id"
    :layer="geoJsonlayer"
    source-id="maps"
  />
</template>

<script>
import { MglGeojsonLayer } from 'vue-mapbox'
import { pointsToGeoJSON } from '@/models/Simulation/SimulationFormDelivery'
export default {
  name: 'SimulationContentDeliveryContentLayerWrapper',
  components: {
    MglGeojsonLayer,
  },
  props: {
    group: {
      type: Object,
      default: null,
    },
    locationsInFrame: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasLocations() {
      return this.locationsInFrame.length !== 0 && !this.group.isEmptyRadius
    },
    geoJsonSource() {
      return {
        data: this.geoJson,
      }
    },
    geoJson() {
      return pointsToGeoJSON(this.locationsInFrame, this.group.radius)
    },
    geoJsonlayer() {
      return {
        id: 'myLayer',
        type: 'fill',
        layout: {},
        paint: {
          'fill-color': 'blue',
          'fill-opacity': 0.3,
        },
      }
    },
  },
}
</script>

<style scoped></style>
